<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mould/in/out/record/report/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('churukushijian')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd"></yi_time_input>
          </el-form-item>

          <el-form-item :label="$t('churukuleixing')">
            <el-select v-model="yt.conditions.type" placeholder="请选择" clearable @change="handleTypeChange">
              <el-option v-for="item in inOutTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('xifenleixing')">
            <el-select v-model="yt.conditions.childType" placeholder="请选择" clearable>
              <el-option v-if="yt.conditions.type === '1'" v-for="item in inBillTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              <el-option v-if="yt.conditions.type === '2'" v-for="item in outBoundTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('danjuhao')">
            <el-input v-model="yt.conditions.billNo" placeholder="请输入单号" clearable></el-input>
          </el-form-item>

          <el-form-item :label="$t('mujubianhao/mingcheng')">
            <yi_cross_select clearable multiple :selectTitle="'no,code,name'" :component="'web_base_mould_list'" :ids.sync="yt.conditions.mouldIds"></yi_cross_select>
          </el-form-item>

          <el-form-item :label="$t('caozuoren')">
            <yi_data_select :type="'customer_user'" :ids.sync="yt.conditions.createBy"> </yi_data_select>
          </el-form-item>

          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain>
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ createTimeStart: begin(), createTimeEnd: end() })">{{ $t('chongzhi') }}</el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>

      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel()"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
    </yi_curd_table>
  </div>
</template>

<script type="text/javascript">
import XLSX from "xlsx";

export default {
  components: {},
  name: "web_report_mold_in_out_record_report_list",
  data() {
    return {
      exportLoading: false,
      inBillTypeJson: this.$store.state.dictJson.MOULD_IN_WAREHOUSING_TYPE || {},
      outBoundTypeJson: this.$store.state.dictJson.MOULD_OUTBOUND_TYPE || {},
      columns: [
        {
          label: "caozuoshijian",
          prop: "createTime",
          type: "time",
          width: 180,
        },
        {
          label: "churukuleixing",
          prop: "type",
          type: 'tag',
          tags: {
            '1': {
              color: '#11beea',
              text: this.$t('ruku')
            },
            '2': {
              color: '#6fe038',
              text: this.$t('chuku')
            },
          },
          width: 100,
        },
        {
          label: "xifenleixing",
          prop: "childType",
          width: 130,
          formatter: (row, column, cellValue) => {
            return this.getChildTypeDisplayValue(row.row.type, row.row.childType);
          },
        },
        {
          label: "danjuhao",
          prop: "billNo",
          width: 160,
        },
        {
          label: "mujubianhao",
          prop: "mould.no",
          width: 130,
        },
        {
          label: "mujubianma",
          prop: "mould.code",
          width: 130,
        },
        {
          label: "mujumingcheng",
          prop: "mould.name",
          width: 130,
        },
        {
          label: "chanpinbianma",
          prop: "material.code",
          width: 130,
        },
        {
          label: "chanpinmingcheng",
          prop: "material.name",
          width: 130,
        },
        {
          label: "shebeimingcheng",
          prop: "equipment.name",
          width: 130,
        },
        {
          label: "cangkumingcheng",
          prop: "warehouse.name",
          width: 130,
        },
        {
          label: "kuqumingcheng",
          prop: "warehouseArea.name",
          width: 130,
        },
        {
          label: "kuweimingcheng",
          prop: "warehouseLocation.name",
          width: 130,
        },
        {
          label: "caozuoren",
          prop: "createByObject.nickname",
          width: 130,
        },
        {
          label: "beizhu",
          prop: "remark",
          width: 150,
        },
      ],
    };
  },
  computed: {
    inOutTypeOptions() {
      return [
        { value: '1', label: this.$t('ruku') },
        { value: '2', label: this.$t('chuku') },
      ];
    },
    inBillTypeOptions() {
      return Object.keys(this.inBillTypeJson).map(key => ({
        value: key,
        label: this.$t(this.inBillTypeJson[key])
      }));
    },
    outBoundTypeOptions() {
      return Object.keys(this.outBoundTypeJson).map(key => ({
        value: key,
        label: this.$t(this.outBoundTypeJson[key])
      }));
    },
  },
  created() {
    setTimeout(() => {
      this.$set(this.yt.conditions, 'createTimeStart', this.begin());
      this.$set(this.yt.conditions, 'createTimeEnd', this.end());
      this.yt.conditions.pageSize = 20;
      this.yt.conditions.orderBy = "createTime desc";
      this.yt.get(1);
    }, 300);
  },
  methods: {
    begin() {
      const date = new Date();
      const begin = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + '01' + ' 00:00:00').getTime();
      return begin;
    },
    end() {
      const date = new Date();
      const end = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59).getTime();
      return end;
    },
    getChildTypeDisplayValue(type, childType) {
      if (type === '1') {
        const found = this.inBillTypeJson[childType];
        return found ? this.$t(found) : childType;
      } else if (type === '2') {
        const found = this.outBoundTypeJson[childType];
        return found ? this.$t(found) : childType;
      } else {
        return childType;
      }
    },
    handleTypeChange() {
      this.yt.conditions.childType = null;
    },
    exportExcel() {
      this.exportLoading = true;
      // 查询全量数据用于导出
      this.http.get('/web/mould/in/out/record/report/page?pageNum=1&pageSize=999999', { params: { ...this.yt.conditions } }).then(res => {
        let tableFirst = this.columns.map(i => this.$t(i.label));
        let tableData = [];
        tableData.push(tableFirst);
        let listData = res.data.rows || [];
        for (let i = 0; i < listData.length; i++) {
          let dataArr = this.getTableDataArr(listData[i], tableFirst);
          tableData.push(dataArr);
        }
        const worksheet = XLSX.utils.aoa_to_sheet(tableData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, `模具出入库流水报表_${this.dayjs().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`);
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    getTableDataArr(row, tableFirst) {
      let dataArr = [];
      dataArr[tableFirst.indexOf(this.$t('caozuoshijian'))] = row.createTime ? this.dayjs(row.createTime).format('YYYY-MM-DD HH:mm:ss') : '';
      dataArr[tableFirst.indexOf(this.$t('churukuleixing'))] = row.type === '1' ? this.$t('ruku') : (row.type === '2' ? this.$t('chuku') : '');
      dataArr[tableFirst.indexOf(this.$t('xifenleixing'))] = this.getChildTypeDisplayValue(row.type, row.childType);
      dataArr[tableFirst.indexOf(this.$t('danjuhao'))] = row.billNo ? row.billNo : '';
      dataArr[tableFirst.indexOf(this.$t('mujubianhao'))] = row.mould ? (row.mould.no || '') : '';
      dataArr[tableFirst.indexOf(this.$t('mujubianma'))] = row.mould ? (row.mould.code || '') : '';
      dataArr[tableFirst.indexOf(this.$t('mujumingcheng'))] = row.mould ? (row.mould.name || '') : '';
      dataArr[tableFirst.indexOf(this.$t('chanpinbianma'))] = row.material ? (row.material.code || '') : '';
      dataArr[tableFirst.indexOf(this.$t('chanpinmingcheng'))] = row.material ? (row.material.name || '') : '';
      dataArr[tableFirst.indexOf(this.$t('shebeimingcheng'))] = row.equipment ? (row.equipment.name || '') : '';
      dataArr[tableFirst.indexOf(this.$t('cangkumingcheng'))] = row.warehouse ? (row.warehouse.name || '') : '';
      dataArr[tableFirst.indexOf(this.$t('kuqumingcheng'))] = row.warehouseArea ? (row.warehouseArea.name || '') : '';
      dataArr[tableFirst.indexOf(this.$t('kuweimingcheng'))] = row.warehouseLocation ? (row.warehouseLocation.name || '') : '';
      dataArr[tableFirst.indexOf(this.$t('caozuoren'))] = row.createByObject ? (row.createByObject.nickname || '') : '';
      dataArr[tableFirst.indexOf(this.$t('beizhu'))] = row.remark ? row.remark : '';
      return dataArr;
    }
  },
};
</script>

<style scoped lang="scss">
</style>
